import script from "./MazdaApiTestPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaApiTestPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaApiTestPanel.vue?vue&type=style&index=0&id=25bb33f7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25bb33f7"]])

export default __exports__